const { USER_ROLE } = require('app/main/util/enums');
const authRoles = {
	superAdmin: ['superAdmin', 'super-admin'],
	admin: [USER_ROLE.ADMIN, 'superAdmin'],
	// Organization admins ONLY (excludes platform super-admins). Use for
	// org-scoped features that have no meaning for a platform principal, e.g.
	// the Heidi LMS (which SSOs into the user's own org on heidiai.io).
	orgAdmin: [USER_ROLE.ADMIN],
	user: [USER_ROLE.ADMIN, USER_ROLE.USER, 'superAdmin'],
	instructor: [USER_ROLE.ADMIN, USER_ROLE.INSTRUCTOR, 'superAdmin'],
	participant: [USER_ROLE.PARTICIPANT],
	demo: [USER_ROLE.DEMO],
	// Any authenticated principal — admins, users, instructors,
	// participants, demos, super-admins. Use for routes that should be
	// reachable by every signed-in role (e.g. personal "My Secrets").
	anyAuthenticated: [
		USER_ROLE.ADMIN, USER_ROLE.USER, USER_ROLE.INSTRUCTOR,
		USER_ROLE.PARTICIPANT, USER_ROLE.DEMO, 'superAdmin',
	],
	onlyGuest: []
};

export default authRoles;
